<router-outlet name="modal"></router-outlet>
<router-outlet name="sidebar"></router-outlet>
<wre-fields></wre-fields>